// 导入axios
import axios from 'axios';
import {
  Notification,
  MessageBox,
  Message
} from 'element-ui'
// var baseURL = '192.168.1.161:8100/';
// 进行一些全局配置
// 公共路由(网络请求地址)
// axios.defaults.baseURL = '192.168.1.161:8100/';
// 请求响应超时时间

// 创建axios实例
const service1 = axios.create({
  baseURL: '/haily',
  // baseURL: 'https://olink.r93535.com:4430/haily',
  // baseURL: 'http://192.168.1.161:8100/haily',
  timeout: 500000
});
const service2 = axios.create({
  baseURL: '/haily',
  timeout: 50000
});

// axios.defaults.timeout = 50000;
var source = null

let pending = []; //声明一个数组用于存储每个ajax请求的取消函数和ajax标识
let cancelToken = axios.CancelToken;
let removePending = (ever) => {
  for (let p in pending) {
    if (pending[p].u === ever.url + '&' + ever.method) { //当当前请求在数组中存在时执行函数体
      pending[p].f(); //执行取消操作
      pending.splice(p, 1); //把这条记录从数组中移除
    }
  }
}

service1.interceptors.request.use(config => {
  console.log('interceptors',config)
  //请求成功后放行
  let whiteList = ['servicesapitest/users/login']
  if (
    whiteList.find((item) => {
      return config.url.indexOf(item) != -1
    }) ||
    sessionStorage.getItem('token')) {
    config.headers["Authorization"] = sessionStorage.getItem('token')
    return config
  } else {
    Message({
      message: `token失效,请重新登录`,
      type: 'error'
    })
    sessionStorage.clear()
    window.open('/login', '_self');
  }
  // return config

}, err => {
  console.log('请求方向失败');
  console.log(err)
})


//响应拦截器
service1.interceptors.response.use(config => {
  console.log('config', config)
  // console.log("进入响应拦截器")
  //请求成功后放行
  removePending(config); //在一个ajax响应后再执行一下取消操作，把已经完成的请求从pending中移除


  // localStorage.setItem("lastTime",new Date().getTime());
  return config
}, error => {
  console.log('响应拦截器失败')
  console.log(error)
  console.log(error.response)
  if (error.request) {
    console.log(error.request)
  } else if (error.response) {
    console.log(error.response.data);
    console.log(error.response.status);
  }
  if (error && error.response) {
    console.log(error.response.data.code)
    switch (error.response.data.code) {
      case 400:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 401:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        sessionStorage.clear()
        window.open('/login', '_self');
        // sessionStorage.removeItem('token')
        // message: `${error.response.data.message}(401)`,
        // window.open('/noPage','_self');
        break;
      case 403:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 404:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        // window.open('/noPage','_self');
        break;
      case 408:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 500:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 501:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 502:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 503:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 504:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 505:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      case 705:
        Message({
          message: `${error.response.data.message}`,
          type: 'error'
        })
        break;
      default:
        Message({
          message: `连接出错(${error.response.status})`,
          type: 'error'
        })

    }
  } else {
    error.message = '连接服务器失败!'
  }
  return Promise.reject(error.response.data)
})





function get(path = '', data = {}) {

  return new Promise(function(resolve, reject) {

    //这可以添加请求拦截器

    service1.get(path, {
        params: data
      }, )
      .then(function(response) {
        // 按需求来，这里我需要的是response.data，所以返回response.data，一般直接返回response
        resolve(response.data);
      })
      .catch(function(error) {
        resolve(error);
      });
  });
}

function post(path, data) {
  let that = this
  // console.log(path,data)
  source = axios.CancelToken.source(); // 这里初始化source对象
  return new Promise(function(resolve, reject) {
    service1.post(
        path,
        data, {
          cancelToken: source.token // 这里声明的cancelToken其实相当于是一个标记          / 当我们要取消请求的时候，可以通过这个找到该请求
        }
      ).then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        resolve(error);
      });
  });
}

function postJson(path, data) {
  let that = this
  // console.log(path,data)
  source = axios.CancelToken.source(); // 这里初始化source对象
  return new Promise(function(resolve, reject) {
    service1.post(
        path,
        data, {
          headers: {
            'Content-Type': 'application/json'
          },
          cancelToken: source.token // 这里声明的cancelToken其实相当于是一个标记          / 当我们要取消请求的时候，可以通过这个找到该请求
        }
      ).then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        resolve(error);
      });
  });
}

function exportHaily(path, data) {
  let that = this
  // console.log(path,data)
  source = axios.CancelToken.source(); // 这里初始化source对象
  return new Promise(function(resolve, reject) {
    service1.post(
        path,
        data, {
          responseType: "arraybuffer",
        }

      )
      .then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        console.log(error)
        reject(error);
      });
  });
}

function upload(path, data) {
  let that = this
  source = axios.CancelToken.source(); // 这里初始化source对象
  return new Promise(function(resolve, reject) {
    service1.post(
        path,
        data, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        }

      ).then(function(response) {
        resolve(response.data);
      })
      .catch(function(error) {
        resolve(error);
      });
  });
}

function cancel() {
  // setTimeout(() => {
  //   console.log("中断请求",source)
  source.cancel('请求中断')
  // },5000)

}
// 封装自己的get/post方法
export default {
  get,
  post,
  cancel,
  upload,
  postJson,
  exportHaily
};



// WEBPACK FOOTER //
// ./src/common/network.js